import FixtureService from '../../services/FixturesService';
import { PRIVATE_EVENTS, PUBLIC_EVENTS, EVENT_CALLBACK } from '../../handlers/EventManager/constants';
import { ASSETS_IMAGES_BASE_URL } from '../../constants/AssetConstants';
import playImage from '../../images/play-white.png';
import notifyImage from '../../images/notification_unfilled.svg';
import tickImage from '../../images/Tick.png';
import './index.scss';
import { JSON_IMAGE_BASE_URL } from '../../constants/FixtureConstants';
import { convertName, convertTime } from '../../helpers/fixtureUtils';
let imgUrl = `https://sportz.sonyliv.com/tennis/flags/`

class FixtureWidgetTennis {
  constructor(sportsManager, fixtureConfig) {
    this.fixtureConfig = fixtureConfig;
    this.assetConfig = this.fixtureConfig.assetConfig
    this.jsonConfig = this.fixtureConfig.jsonManagerConfig
    this.sportsManager = sportsManager;
    if (!this.sportsManager) {
      throw new Error('Sports manager is required in Fixtures view.');
    }

    this.eventManager = this.sportsManager.eventManager;
    if (!this.eventManager) {
      throw new Error('Event manager is required in Fixtures view.');
    }

    this.parentDom = document.getElementById(this.assetConfig.parentId);
    if (!this.parentDom) {
      this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS?.SPORTS_MANAGER_ERROR, {
        errorCode: 'err_100',
        errorMessage: 'DOM element is required in fixtures view.',
      });
    }

    this.fixtureData = null;
    this.FEData = this.assetConfig.FEData;
    this.handleCTAClick = this.assetConfig.handleCtaClick;
    this.handleViewAllCard = this.assetConfig.handleViewAllCard;
    this.reminderIds = this.assetConfig.reminderIds;
    this.sportId = this.assetConfig.sportId;
    this.tourId = this.assetConfig.tourId;
    this.widgetCallback = this.assetConfig.widgetCallback

    if (!this.sportId || !this.tourId) {
      this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS?.SPORTS_MANAGER_ERROR, {
        errorCode: 'err_100',
        errorMessage: 'Sports id and tournament is required in fixtures view.',
      });
    }

    this.fixtureStatus = this.assetConfig.status;
    this.completedMatchLength = 0;
    this.liveMatchLength = 0;
    this.upcomingMatchLength = 0;
    this.isDoublesMatch = false;
    this.subscribeToEvents();
  }

  subscribeToEvents() {
    this.eventManager.subscribeToEvents({
      eventType: EVENT_CALLBACK.PRIVATE_EVENTS,
      eventCallback: this.privateEventCallback.bind(this),
      senderName: 'FIXTURE_SERVICE',
    });
  }

  fixtureDataOrdering() {
    let completedMatch = []
    let upcomingMatch = []
    let liveMatch = []
    this.fixtureData.map((match) => {
      if(match?.is_live == true) {
        liveMatch.push(match)
      } else if (match?.is_complete == true) {
        completedMatch.push(match)
      } else if (match?.is_upcoming == true) {
        upcomingMatch.push(match)
      }
    });
    if(liveMatch.length > 0 || upcomingMatch?.length > 0) {
      completedMatch = completedMatch.reverse()
    }
    this.fixtureData = [...completedMatch, ...liveMatch, ...upcomingMatch]
    this.completedMatchLength = completedMatch?.length
    this.liveMatchLength = liveMatch?.length
    this.upcomingMatchLength = upcomingMatch?.length
  }

  privateEventCallback(eventName, eventData) {
    switch (eventName) {
      case PRIVATE_EVENTS.FIXTURE_UPDATE: {
        this.fixtureData = eventData?.fixtureWidgetData;
        this.tourMetaData = eventData?.tourMetaData;
        // this.fixtureDataOrdering();
        this.render();
        break;
      }

    }
  }

  getFixtureData() {
    const fixtureService = new FixtureService(this.sportsManager);
    fixtureService.fetchFixtureData(this.sportId, this.tourId, this.fixtureStatus, 0, PRIVATE_EVENTS.FIXTURE_UPDATE,this.jsonConfig);
  }

  destroyFixtureSDK() {
    if(this.parentDom) {
      this.parentDom.innerHTML = "";
      this.eventManager.broadcastPrivateEvent(PRIVATE_EVENTS.FIXTURE_WIDGET_DESTROY);
    }
  }

  renderCard(match,index) {
    const fixtureCard = document.createElement('a');
    const fixtureOuterWrap = document.createElement('div');
    fixtureOuterWrap.setAttribute('class', 'fixture-outer-Wrap');
    fixtureOuterWrap.classList.add('fixture-card');

    this.handleCTAClick("SET_HREF", match?.match_metadata, (route, isHrefEnabled) => {
      fixtureCard.href = route
      if(isHrefEnabled === false) {
        fixtureCard.classList.add("disablePointer")
      }
    });
    if(this.completedMatchLength > 0 && index == this.completedMatchLength-1 && (this.liveMatchLength > 0 || this.upcomingMatchLength > 0)) {
      fixtureCard.classList.add("scrollToview")
    }

    
    fixtureCard.appendChild(fixtureOuterWrap);

    if(!match?.upcoming){
      const fixtureMatchStatus = document.createElement('div');
      fixtureMatchStatus.setAttribute('class', 'fixture-match-status');
      fixtureMatchStatus.innerText = match?.matchstatus;
      fixtureOuterWrap.appendChild(fixtureMatchStatus);

      const teamDetails = document.createElement('div');
      teamDetails.setAttribute('class', 'fixture-team-details');
      fixtureOuterWrap.appendChild(teamDetails);

      const fixtureHomeTeam = document.createElement('div');
      fixtureHomeTeam.setAttribute('class', 'fixture-home-team');
      teamDetails.appendChild(fixtureHomeTeam);

      const homeDetails = this.renderTeamDetails('home', match.teama_info, match.teama_score, match);
      fixtureHomeTeam.appendChild(homeDetails);

      const homeScoreDetails = this.renderScoreDetails(match.teama_id, match.sets)
      fixtureHomeTeam.appendChild(homeScoreDetails);

      const fixtureAwayTeam = document.createElement('div');
      fixtureAwayTeam.setAttribute('class', 'fixture-away-team');
      teamDetails.appendChild(fixtureAwayTeam);

      const awayDetails = this.renderTeamDetails('away', match.teamb_info, match.teamb_score, match);
      fixtureAwayTeam.appendChild(awayDetails);

      const awayScoreDetails = this.renderScoreDetails(match.teamb_id, match.sets)
      fixtureAwayTeam.appendChild(awayScoreDetails);

    } else {
      this.isDoublesMatch = (match?.teama_info?.length > 1) || false;
      let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL;

      if(this.isDoublesMatch){
        const fixtureMatchTime = document.createElement('div');
        fixtureMatchTime.setAttribute('class', 'doubles-fixture-match-time');
        fixtureMatchTime.innerText = convertTime(match?.matchtime_ist);
        fixtureOuterWrap.appendChild(fixtureMatchTime);

        const doublesFixtureContainer = document.createElement('div');
        doublesFixtureContainer.setAttribute('class', 'doubles-fixture-container');

        const teamA = document.createElement('div');
        teamA.setAttribute('class', 'doubles-fixture-team-wrapper');

        const teamAPlayerAWrapper = document.createElement('div');
        teamAPlayerAWrapper.setAttribute('class', 'doubles-fixture-team-player-wrapper');

        const teamAPlayerALogo = new Image();
        teamAPlayerALogo.src = `${imgUrl}${match?.teama_info[0]?.country_id}.png`;
        teamAPlayerALogo.onerror = function (e) {
          teamAPlayerALogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
        }

        const teamAPlayerALabel = document.createElement('div');
        teamAPlayerALabel.setAttribute('class', 'doubles-fixture-team-label');
        teamAPlayerALabel.innerText = convertName(match?.teama_info[0]?.name);

        teamAPlayerAWrapper.appendChild(teamAPlayerALogo);
        teamAPlayerAWrapper.appendChild(teamAPlayerALabel);

        teamA.appendChild(teamAPlayerAWrapper);

        const teamAPlayerBWrapper = document.createElement('div');
        teamAPlayerBWrapper.setAttribute('class', 'doubles-fixture-team-player-wrapper');

        const teamAPlayerBLogo = new Image();
        teamAPlayerBLogo.src = `${imgUrl}${match?.teama_info[1]?.country_id}.png`;
        teamAPlayerBLogo.onerror = function (e) {
          teamAPlayerBLogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
        }

        const teamAPlayerBLabel = document.createElement('div');
        teamAPlayerBLabel.setAttribute('class', 'doubles-fixture-team-label');
        teamAPlayerBLabel.innerText = convertName(match?.teama_info[1]?.name);

        teamAPlayerBWrapper.appendChild(teamAPlayerBLogo);
        teamAPlayerBWrapper.appendChild(teamAPlayerBLabel);

        teamA.appendChild(teamAPlayerBWrapper);

        const versusContainer = document.createElement('div');
        versusContainer.setAttribute('class', 'doubles-versus-container')
        versusContainer.innerText = "V"

        const teamB = document.createElement('div');
        teamB.setAttribute('class', 'doubles-fixture-team-wrapper');

        const teamBPlayerAWrapper = document.createElement('div');
        teamBPlayerAWrapper.setAttribute('class', 'doubles-fixture-team-player-wrapper');
        teamBPlayerAWrapper.classList.add("doubles-player-team-b");

        const teamBPlayerALogo = new Image();
        teamBPlayerALogo.src = `${imgUrl}${match?.teamb_info[0]?.country_id}.png`;
        teamBPlayerALogo.onerror = function (e) {
          teamBPlayerALogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
        }

        const teamBPlayerALabel = document.createElement('div');
        teamBPlayerALabel.setAttribute('class', 'doubles-fixture-team-label');
        teamBPlayerALabel.innerText = convertName(match?.teamb_info[0]?.name);

        teamBPlayerAWrapper.appendChild(teamBPlayerALabel);
        teamBPlayerAWrapper.appendChild(teamBPlayerALogo);

        teamB.appendChild(teamBPlayerAWrapper);

        const teamBPlayerBWrapper = document.createElement('div');
        teamBPlayerBWrapper.setAttribute('class', 'doubles-fixture-team-player-wrapper');
        teamBPlayerBWrapper.classList.add("doubles-player-team-b");

        const teamBPlayerBLogo = new Image();
        teamBPlayerBLogo.src = `${imgUrl}${match?.teamb_info[1]?.country_id}.png`;
        teamBPlayerBLogo.onerror = function (e) {
          teamBPlayerBLogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
        }

        const teamBPlayerBLabel = document.createElement('div');
        teamBPlayerBLabel.setAttribute('class', 'doubles-fixture-team-label');
        teamBPlayerBLabel.innerText = convertName(match?.teamb_info[1]?.name);

        teamBPlayerBWrapper.appendChild(teamBPlayerBLabel);
        teamBPlayerBWrapper.appendChild(teamBPlayerBLogo);

        teamB.appendChild(teamBPlayerBWrapper);

        doublesFixtureContainer.appendChild(teamA);
        doublesFixtureContainer.appendChild(versusContainer);
        doublesFixtureContainer.appendChild(teamB);

        fixtureOuterWrap.appendChild(doublesFixtureContainer);

      } else {
        const singlesFixtureContainer = document.createElement('div');
        singlesFixtureContainer.setAttribute('class', 'singles-fixture-container');

        const teamA = document.createElement('div');
        teamA.setAttribute('class', 'singles-fixture-team-wrapper');
        const teamALogo = new Image();
        teamALogo.src = `${imgUrl}${match?.teama_info[0]?.country_id}.png`;
        teamALogo.onerror = function (e) {
          teamALogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
        }
        const teamALabel = document.createElement('div');
        teamALabel.setAttribute('class', 'singles-fixture-team-label');
        teamALabel.innerText = convertName(match?.teama);

        teamA.appendChild(teamALogo);
        teamA.appendChild(teamALabel);

        const teamB = document.createElement('div');
        teamB.setAttribute('class', 'singles-fixture-team-wrapper');
        const teamBLogo = new Image();
        teamBLogo.src = `${imgUrl}${match?.teamb_info[0]?.country_id}.png`;
        teamBLogo.onerror = function (e) {
          teamBLogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
        }
        const teamBLabel = document.createElement('div');
        teamBLabel.setAttribute('class', 'singles-fixture-team-label');
        teamBLabel.innerText = convertName(match?.teamb);

        teamB.appendChild(teamBLogo);
        teamB.appendChild(teamBLabel);

        singlesFixtureContainer.appendChild(teamA)
        singlesFixtureContainer.appendChild(teamB)

        const singlesFixtureTimeContainer = document.createElement('div');
        singlesFixtureTimeContainer.setAttribute('class', 'singles-fixture-time-conatiner');
        singlesFixtureTimeContainer.innerText = convertTime(match?.matchtime_ist);

        const singlesFixtureWrapper = document.createElement('div');
        singlesFixtureWrapper.setAttribute('class', 'singles-fixture-wrapper');

        singlesFixtureWrapper.appendChild(singlesFixtureContainer);
        singlesFixtureWrapper.appendChild(singlesFixtureTimeContainer);
        fixtureOuterWrap.appendChild(singlesFixtureWrapper);
      }
      
    }  

    let reminderIds = typeof localStorage != "undefined" && localStorage.getItem("sports_reminders") ? JSON.parse(localStorage.getItem("sports_reminders")) : this.reminderIds;
    let reminderAddId = typeof localStorage != "undefined" && localStorage.getItem("reminderMatchTourId") ?  localStorage.getItem("reminderMatchTourId") : "";
    if(reminderAddId && !reminderIds.includes(reminderAddId)) {
      reminderIds.push(reminderAddId)
    }
    let isSetReminder = reminderIds?.filter((item) => {
      return item.includes(match.match_id);
    });

    if ((match?.metaDatum?.objectSubtype == "HIGHLIGHTS" && match?.metaDatum?.contentId != 0)) {
      const buttonsContainer = document.createElement('div');
      buttonsContainer.setAttribute('class', 'fixture_btn_container');
      fixtureOuterWrap.appendChild(buttonsContainer);
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-completed');
      fixtureButtonContainer.href = "javascript:void(0);";
      const ActionImg = new Image();
      ActionImg.src = playImage;
      fixtureButtonContainer.appendChild(ActionImg);
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.textContent = 'Watch Highlights';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      fixtureButtonContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCTAClick('WATCH_HIGHLIGHTS_EVENTS', match);
      });
      buttonsContainer.appendChild(fixtureButtonContainer);
    } else if (!match?.metaDatum?.objectSubtype && match?.matchstatus_id == "12" && (match?.match_id!= 0 || match?.metaDatum?.contentId != 0) && match?.releaseStartDate != 0 ) {
      const buttonsContainer = document.createElement('div');
      buttonsContainer.setAttribute('class', 'fixture_btn_container');
      fixtureOuterWrap.appendChild(buttonsContainer);
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-completed');
      fixtureButtonContainer.href = "javascript:void(0);";
      const ActionImg = new Image();
      ActionImg.src =  playImage;
      fixtureButtonContainer.appendChild(ActionImg);
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.textContent = 'Watch Preview';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      fixtureButtonContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCTAClick('WATCH_PREVIEW_EVENTS', match);
      });

      if(match?.metaDatum?.contentId != 0){
        buttonsContainer.appendChild(fixtureButtonContainer);
      }

      const fixtureNotificationContainer = document.createElement('a');
      fixtureNotificationContainer.setAttribute('class', 'fixture-button-notification fixture-match-completed');
      fixtureNotificationContainer.href = "javascript:void(0);";
      const NotificationImg = new Image();
      NotificationImg.src = notifyImage;
      const fixtureNotificationText = document.createElement('span');
      fixtureNotificationText.setAttribute('class', 'fixture-notification-text');
      fixtureNotificationText.innerHTML = 'Set Reminder'
      fixtureNotificationContainer.appendChild(NotificationImg);
      fixtureNotificationContainer.appendChild(fixtureNotificationText);

      if(isSetReminder?.length > 0) {
        fixtureNotificationContainer.classList.add("disabled")
        NotificationImg.src = tickImage;
        fixtureNotificationText.innerHTML = 'Reminder Set'
      }
      fixtureNotificationContainer.addEventListener("click",(e) => {
        e.stopPropagation();
        if(!e.currentTarget.classList.contains("disabled")) {
          this.handleCTAClick("SET_REMINDER_EVENTS",match,(setReminderStatus) => {
            if(setReminderStatus == true) {
              fixtureNotificationContainer.classList.add("disabled")
              NotificationImg.src = tickImage;
              fixtureNotificationText.innerHTML = 'Reminder Set'
            }
          });
        }
      });
      buttonsContainer.appendChild(fixtureNotificationContainer);
    } else if (match?.metaDatum?.objectSubtype == "LIVE_SPORT" && match?.metaDatum?.contentId != 0) {
      const buttonsContainer = document.createElement('div');
      buttonsContainer.setAttribute('class', 'fixture_btn_container');
      fixtureOuterWrap.appendChild(buttonsContainer);
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont');
      fixtureButtonContainer.classList.add('live-btn-container');
      fixtureButtonContainer.href = "javascript:void(0);";
      const liveIcon = document.createElement('div');
      liveIcon.setAttribute('class', 'live-circle')
      fixtureButtonContainer.appendChild(liveIcon);
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.classList.add('live-btn');
      fixtureButtonText.textContent = 'Watch Live';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      if(match?.metaDatum?.contractStartDate != 0 && match?.metaDatum?.contractStartDate > Date.now()){
        fixtureButtonContainer.style.display = 'none'
        let delta = match?.metaDatum?.contractStartDate - Date.now()
        setTimeout(()=> {
            fixtureButtonContainer.style.display = 'flex'
        },delta)
      }
      fixtureButtonContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCTAClick('WATCH_LIVE_EVENTS', match);
      });
      buttonsContainer.appendChild(fixtureButtonContainer);
    }

    if(typeof localStorage != "undefined" && localStorage.getItem("FIXTURE_CLICK_ENABLED") == 'true') {
      fixtureCard.addEventListener("click",(e) => {
        e.preventDefault();
        this.handleCTAClick("FIXTURE_CARD_CLICK", match);
      });
    }

    const tourNameContainer = document.createElement('div');
    tourNameContainer.setAttribute('class', 'tour-name-container');
    tourNameContainer.innerText = match?.series_short_display_name;
    fixtureCard.appendChild(tourNameContainer);
    // document.getElementsByClassName('fixture-container-slides')[0].appendChild(fixtureCard);

    const matchDate = document.createElement('div');
    matchDate.setAttribute('class', 'fixture-match-date-outer');
    const dateFormat = new Date(match.matchdate_ist).toLocaleDateString('en-US', {
      weekday: 'long', day: '2-digit', month: 'short' 
    });

    matchDate.innerText = `${dateFormat}`;
    fixtureCard.appendChild(matchDate);
    
    this.wrapperSlides.appendChild(fixtureCard);
  }

  renderScoreDetails(teamId, score){
    let teamScore = '';

    score.forEach(set => {
      const teamSetScore = set.set_score[teamId];
      const opponentSetScore = Object.values(set.set_score).find(score => score !== teamSetScore);

      const scoreClass = teamSetScore > opponentSetScore ? '' : 'blur';

      teamScore += `<span class="${scoreClass}">${teamSetScore}</span> `;
    });

    const scoreArea = document.createElement('div');
    scoreArea.setAttribute('class', 'tennis-score-container');
    scoreArea.innerHTML = teamScore.trim();

    return scoreArea;
  }

  renderTeamDetails(teamType, teamInfoData, match) {
    const logoImg = new Image();
    const logoImg1 = new Image();
    let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL;
    logoImg.onerror = function (e) {
      logoImg.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
    }
    logoImg1.onerror = function (e) {
      logoImg1.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
    }
    if(teamInfoData && teamInfoData?.length > 0 && teamInfoData?.length == 1){
      const team1CountryLogo = `${imgUrl}${teamInfoData[0]?.country_id}.png`;
      logoImg.src = team1CountryLogo;
      logoImg.alt = teamInfoData[0]?.name;
      const classList = `team-info-wrapper team-info-wrapper--${teamType}`;
      let wrapper = document.createElement('span');
      wrapper.setAttribute('class', classList);
      let teamMetaData = match?.teama_metadata;
      if(teamType === "away") {
          teamMetaData = match?.teamb_metadata;
      }
      this.handleCTAClick("SET_HREF", teamMetaData, (route, isHrefEnabled) => {
          wrapper.href = route
          if(isHrefEnabled === false) {
            wrapper.classList.add("disablePointer")
          }        
      });
      const teamLabel = document.createElement('div');
      teamLabel.setAttribute('class', 'team-name-label');
      teamLabel.innerText = convertName(teamInfoData[0]?.name);
      wrapper.appendChild(logoImg);
      wrapper.appendChild(teamLabel);
      return wrapper;
    }else{
      const team1CountryLogo = `${imgUrl}${teamInfoData[0]?.country_id}.png`;
      const team2CountryLogo = `${imgUrl}${teamInfoData[1]?.country_id}.png`;
      logoImg.src = team1CountryLogo;
      logoImg.alt = teamInfoData[0]?.name;
      logoImg1.src = team2CountryLogo;
      logoImg1.alt = teamInfoData[1]?.name;
      const classList = `team-info-wrapper team-info-wrapper--${teamType}`;
      let wrapper = document.createElement('span');
      wrapper.setAttribute('class', classList);
      let teamMetaData = match?.teama_metadata;
      if(teamType === "away") {
          teamMetaData = match?.teamb_metadata;
      }
      this.handleCTAClick("SET_HREF", teamMetaData, (route, isHrefEnabled) => {
          wrapper.href = route
          if(isHrefEnabled === false) {
            wrapper.classList.add("disablePointer")
          }        
      });
      const teamLabel = document.createElement('div');
      teamLabel.setAttribute('class', 'team-name-label');
      teamLabel.innerText = convertName(teamInfoData[0]?.name) + ' / ';
      wrapper.appendChild(logoImg);
      wrapper.appendChild(teamLabel);
      const teamLabel1 = document.createElement('div');
      teamLabel1.setAttribute('class', 'team-name-label');
      teamLabel1.innerText = convertName(teamInfoData[1]?.name);
      wrapper.appendChild(logoImg1);
      wrapper.appendChild(teamLabel1);
      return wrapper;
    }
  }

  renderTeamDetailsUpcoming(teamType, image, match) {
    this.isDoublesMatch = (match?.teama_info?.length > 1) || false;
    const logoImg = new Image();
    logoImg.src = image;
    logoImg.onerror = function (e) {
      logoImg.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
    }
    logoImg.alt = teamName;
    const classList = `team-info-wrapper team-info-wrapper--${teamType}`;
    let wrapper = document.createElement('a');
    wrapper.setAttribute('class', classList);
    let teamMetaData = match?.teama_metadata;
    if(teamType === "away") {
        teamMetaData = match?.teamb_metadata;
    }
    this.handleCTAClick("SET_HREF", teamMetaData, (route, isHrefEnabled) => {
        wrapper.href = route
        if(isHrefEnabled === false) {
          wrapper.classList.add("disablePointer")
        }        
    });
    const teamLabel = document.createElement('div');
    teamLabel.setAttribute('class', 'team-name-label');
    teamLabel.innerText = teamName;
    wrapper.appendChild(logoImg);
    wrapper.appendChild(teamLabel);
    return wrapper;
  }

  render() {
    if (this.parentDom && this.fixtureData.length > 0) {
      const numberOfCards = this.FEData?.metadata?.number_ofcard_displayed || 10;
      const wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'fixture-container-tennis');
      this.parentDom.appendChild(wrapper);
      const leftArrowCont = document.createElement('div');
      leftArrowCont.setAttribute('id', 'fixture-prev-arrow');
      wrapper.appendChild(leftArrowCont);
      this.wrapperSlides = document.createElement('div');
      this.wrapperSlides.setAttribute('class', 'fixture-container-slides');
      wrapper.appendChild(this.wrapperSlides);

      const matches = this.fixtureData.slice(0, numberOfCards);

      const showConcluded = matches.some(
        (match) =>
          match.tennis?.upcoming === false ||
          match.upcoming === false 
      );

      const showUpcoming = matches.some(
        (match) =>
          match.tennis?.upcoming === true ||
          match.upcoming === true 
      );

      if(this.fixtureStatus !== "upcoming" && showConcluded) {
        const fixtureCardViewConclude = document.createElement('div');
        fixtureCardViewConclude.setAttribute('class', 'fixture-card fixture-card-view-cont');
        const fixtureVeiwAllConcludeLabel = document.createElement('div');
        fixtureVeiwAllConcludeLabel.setAttribute('class', 'fixture-card-view-all');
        fixtureVeiwAllConcludeLabel.innerText = 'View All Concluded Games';
        fixtureCardViewConclude.appendChild(fixtureVeiwAllConcludeLabel);
        fixtureCardViewConclude?.addEventListener('click', () => { this.handleViewAllCard(this.tourMetaData, 'concluded') } );

        if(document.getElementsByClassName('fixture-container-slides').length >  0) {
          this.wrapperSlides.appendChild(fixtureCardViewConclude);
        }
      }
      this.fixtureData.slice(0, numberOfCards).map((match,index) => {
        this.renderCard(match?.tennis ? match?.tennis : match, index);
      });

      if(this.fixtureStatus !== "concluded" && showUpcoming) {
        const fixtureCardViewCont = document.createElement('div');
        fixtureCardViewCont.setAttribute('class', 'fixture-card fixture-card-view-cont');
        const fixtureVeiwAllLabel = document.createElement('div');
        fixtureVeiwAllLabel.setAttribute('class', 'fixture-card-view-all');
        fixtureVeiwAllLabel.innerText = 'View All Upcoming Matches';
        fixtureCardViewCont.appendChild(fixtureVeiwAllLabel);
        fixtureCardViewCont?.addEventListener('click', () => { this.handleViewAllCard(this.tourMetaData, 'upcoming') } );
        if(document.getElementsByClassName('fixture-container-slides').length >  0) {
          // document.getElementsByClassName('fixture-container-slides')[0].appendChild(fixtureCardViewCont);
          this.wrapperSlides.appendChild(fixtureCardViewCont);
        }
      }
      const rigthArrowCont = document.createElement('div');
      rigthArrowCont.setAttribute('id', 'fixture-next-arrow');
      wrapper.appendChild(rigthArrowCont);

      rigthArrowCont.addEventListener('click', () => {
        this.wrapperSlides.scrollLeft += this.wrapperSlides.clientWidth / 1.5;
      });

      leftArrowCont.addEventListener('click', () => {
        this.wrapperSlides.scrollLeft -= this.wrapperSlides.clientWidth / 1.5;
      });

      this.wrapperSlides.onscroll = (event) => {
        this.toggleArrows(this.wrapperSlides, rigthArrowCont, leftArrowCont);
      };

      this.widgetCallback("FIXTURE_RENDER_SUCCESS",this.tourMetaData)

      let element =
        this.wrapperSlides.getElementsByClassName('live-btn-container')[0] ||
        this.wrapperSlides.getElementsByClassName('fixture-button-notification')[0];
      setTimeout(()=> {
        if(element) {
          let elementRect = element?.getBoundingClientRect();
          this.wrapperSlides.scroll({ 
            left: elementRect.left - 120, 
            behavior: "smooth" 
          });
        }
      }, 0)
      this.toggleArrows(this.wrapperSlides, rigthArrowCont, leftArrowCont);

    }
  }

  toggleArrows(container, rigthArrowCont, leftArrowCont) {
    if (container.scrollLeft === 0) {
      leftArrowCont.style.display = 'none';
      container.style.marginLeft ='4.3924vw';
    } else {
      leftArrowCont.style.display = 'block';
      container.style.marginLeft = 0;
    } 

    if (container.scrollLeft + container.clientWidth === container.scrollWidth) {
      rigthArrowCont.style.display = 'none';
    } else {
      rigthArrowCont.style.display = 'block';
      if (container.scrollLeft > 0) {
        leftArrowCont.style.display = 'block';
      }
    }
  }

  tConvert(time) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  
    if (time.length > 1) { // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  convertName(fullName) {
      const nameParts = fullName.split(' ');
      if (nameParts.length > 1) {
          return `${nameParts[0]} ${nameParts[1][0]}`;
      }
      return fullName; // Return the original name if it doesn't have a space
  }
}

export default FixtureWidgetTennis;
